import { Medicion } from "./Medicion";

export class RecepcionCombustibleContenedor {
    codigoTanque: string;
    medicionPrevia: Medicion;
    medicionFinal: Medicion;
    aptoCantidad: boolean;
    cantidad: number;
    cantidad15: number;
    vacio: number;
    codigoProducto: string;
}